<template>
  <v-row class="my-8 px-3">
    <v-col
      class="research-directions-banner rounded-6 py-0 px-md-5 px-lx-8"
      cols="12"
      :style="{ backgroundImage: `url(${images.bannerBackgroundBottom})` }"
    >
      <a
        class="research-directions-banner__link"
        :href="researchDirectionsUrl"
        aria-label="What is Research Directions? Learn More [opens in a new tab]"
        target="_blank"
      >
        <v-row align="center">
          <v-col class="d-flex align-center" cols="12" md="5" lg="6">
            <ResearchDirectionsQuestionMarkIcon
              id="researchDirectionsIconBannerBottom"
              class="mr-2 inverted--text"
              focusable="false"
              aria-hidden="true"
            />
            <span class="research-directions-banner__text inverted--text"
              >What is Research Directions?</span
            >
          </v-col>
          <v-col class="d-flex justify-md-end" cols="12" md="7" lg="6">
            <div
              class="research-directions-banner__button rounded-6 order-md-1 focused inverted--text px-2 px-sm-6 py-2"
            >
              Learn More
            </div>
            <img
              class="width-220 pl-5 order-md-0"
              :src="images.logo"
              alt="Research directions logo"
            />
          </v-col>
        </v-row>
      </a>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from "vuex";

import ResearchDirectionsQuestionMarkIcon from "~/components/research-directions/icons/ResearchDirectionsQuestionMarkIcon.vue";

export default {
  name: "ResearchDirectionsBannerBottom",
  components: {
    ResearchDirectionsQuestionMarkIcon,
  },
  data() {
    return {
      researchDirectionsUrl:
        "https://www.cambridge.org/core/what-we-publish/collections/research-directions",
    };
  },
  computed: {
    ...mapState({
      images: (state) => state.theme.images.researchDirections,
    }),
  },
};
</script>

<style scoped lang="scss">
.research-directions-banner {
  background-size: cover;
  background-position: bottom center;
  font-weight: 500;

  &__link {
    text-decoration: none;
  }

  &__text {
    font-size: 20px;
  }

  &__button {
    font-size: 14px;
  }
}
</style>
